import {useEffect, useState} from 'react';
import {Loading, LoadingError} from './LoadingFork';
import authManager from "../lib/authManager";
import { Alert } from './Alert';
import api from '../lib/api';

export function RestProxyPage({ history }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    useEffect(() => {
      (async () => {
        await authManager.updateAuthState();

        if (!authManager.isAuthenticated) return history.replace('/login');

        setIsAuthenticated(true);
      })();
    }, []);

    useEffect(() => {
      if (!isAuthenticated) return;

      (async () => {
        const endpoint = history.location.pathname;

        try {
          const res = await api.proxy(endpoint);

          const { data } = res;

          setMessage(data.message);
          setError(null);

        } catch (err) {
          setError(err?.message || "Something is wrong");
        } finally {
          setLoading(false);
        }
      })();
    }, [isAuthenticated]);

    if (loading) return <Loading/>
    if (error) return <LoadingError error={error}/>

    return (
      <Alert spaceAbove="medium" flavour="success">
        {message || 'Successful'}
      </Alert>
    )
}
